module.exports = __webpack_public_path__ + "img/2015-3.705eff86.jpg";